import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/toxicologia/informes-sobre-impurezas-elementales")({
  beforeLoad: () => { throw redirect({ href: "/es/servicios/toxicologia-regulatoria/informes-sobre-impurezas-elementales", statusCode: 301 }); },
});
